import { FC } from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";



const CustomComponentForTransfer: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {



  return (
    <div className="row">
      <div className="col-6 p-2">
        <div className="card mt-3">
          <div className="card-header">
            <h5 className="m-0 text-center text-primary">Transfers (vs previous year)
            </h5>
          </div>
          <div className="card-body">
            <h6 className="text-center">
              {StatisticsObjectType.transfers_vs_previous_year}
            </h6>
          </div>
        </div>
      </div>
      <div className="col-6 p-2">
        <div className="card mt-3">
          <div className="card-header">
            <h5 className="m-0 text-center text-primary">Case Volume (vs previous year)
            </h5>
          </div>
          <div className="card-body">
            <h6 className="text-center">
             {StatisticsObjectType.case_vol_vs_previous_year}
            </h6>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CustomComponentForTransfer;
